import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ICustomerWalletCategory } from "../../interfaces/customer-wallet.interface";
import * as Highcharts from 'highcharts';


@Component({
    selector: 'customer-wallet-categories-chart',
    templateUrl: './categories-chart.component.html',
    styleUrls: ['./categories-chart.component.scss'],
})
export class CustomerWalletCategoriesChartComponent implements AfterViewInit, OnChanges, OnInit {

    @ViewChild('customerWalletChart', { static: true })
    public customerWalletChart: ElementRef<HTMLDivElement>;

    @Input()
    public categories: ICustomerWalletCategory[] = [];

    @Input()
    public colorOnlyCategory: string;

    @Input()
    public amount: number = 0;

    @Input()
    public disableHideAmount = false;

    @Input()
    public lastUpdate: string | Date = new Date();

    @Input()
    public amountLabel: string = '';

    public ngAfterViewInit(): void {
        this.plotChart();
    }

    public ngOnInit() {
        if (this.amount == 0) {
            this.amount = this.categories.reduce((total, { allocationAmount }) => total + allocationAmount, 0);
        }
    }

    public ngOnChanges({ colorOnlyCategory }: SimpleChanges): void {
        if (colorOnlyCategory) {
            this.plotChart();
        }
    }

    public get hideAmount() {
        return !this.disableHideAmount && window.localStorage.getItem('showTraderInfoValues') === 'false';
    }

    private plotChart() {
        if (this.customerWalletChart) {
            Highcharts.chart(this.customerWalletChart.nativeElement, {
                chart: {
                    animation: false,
                    renderTo: 'customer-wallet-chart',
                    type: 'pie',
                    height: 292,
                },
                title: {
                    text: ''
                },
                plotOptions: {
                    pie: {
                        shadow: false,
                        borderWidth: 0,
                    },
                    series: {
                        enableMouseTracking: false,
                        // animation: false,
                    }
                },
                tooltip: {
                    enabled: false
                },
                series: [{
                    type: 'pie',
                    name: '',
                    data: this.categories.map(category => category.allocationPercentage),
                    colors: this.categories.map(category => {
                        return this.colorOnlyCategory && this.colorOnlyCategory != category.slug ? '#F6F8FB' : category.color;
                    }),
                    // size: '80vw',
                    innerSize: '85%',
                    showInLegend: false,
                    dataLabels: {
                        enabled: false
                    }
                }]
            });
        }
    }

}